import script from "./ListasSistemaAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./ListasSistemaAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./ListasSistemaAdministrar.vue?vue&type=style&index=0&id=59514174&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59514174"]])

export default __exports__